import { useEffect, useState } from 'react'
import { api, session } from '../api.js'

export default function Collectivites({ moi }) {
  const [liste, setListe] = useState([])
  const [creation, setCreation] = useState(false)

  const charger = () => api.orgs().then(setListe)
  useEffect(() => { charger() }, [])   // eslint-disable-line

  return (
    <>
      <h1>Mes collectivités</h1>
      <p className="chapo">Chaque collectivité a son portail, ses démarches, ses agents et ses
        données. Rien ne circule de l'une à l'autre sans une décision explicite.</p>
      <button className="btn pri" onClick={() => setCreation(!creation)}>
        {creation ? 'Annuler' : 'Ajouter une collectivité'}
      </button>

      {creation && <Formulaire onCree={() => { setCreation(false); charger() }} />}

      <div className="grille">
        {liste.map((o) => (
          <article className="fiche" key={o.id}>
            <h3>{o.name}</h3>
            <p className="mono petit">
              {o.kind === 'agglo' ? 'Intercommunalité' : 'Commune'} · {o.population.toLocaleString('fr-FR')} habitants
            </p>
            <dl className="chiffres">
              <div><dt>démarches en ligne</dt><dd>{o.forms_live}</dd></div>
              <div><dt>dossiers en cours</dt><dd>{o.requests_open}</dd></div>
            </dl>
            <p className="aide">
              {o.published_at
                ? `En ligne depuis le ${new Date(o.published_at).toLocaleDateString('fr-FR')}`
                : 'Portail encore en préparation'}
            </p>
            <div className="ligne">
              <button className="btn sm pri" onClick={() => {
                session.setOrg(o.id); window.location.reload()
              }}>Ouvrir</button>
              <a className="btn sm" href={o.portal} target="_blank" rel="noreferrer">Portail</a>
            </div>
          </article>
        ))}
      </div>
    </>
  )
}

function Formulaire({ onCree }) {
  const [nom, setNom] = useState('Mairie de ')
  const [slug, setSlug] = useState('')
  const [pop, setPop] = useState(800)
  const [erreur, setErreur] = useState('')
  const [domaine, setDomaine] = useState('ucivis.fr')

  useEffect(() => { api.config().then((c) => setDomaine(c.base_domain)).catch(() => {}) }, [])

  async function creer(e) {
    e.preventDefault()
    try {
      await api.createOrg({ name: nom, slug: slug || auto(nom), population: Number(pop) })
      onCree()
    } catch (err) { setErreur(err.message) }
  }

  return (
    <form className="carte" onSubmit={creer}>
      <h2>Nouvelle collectivité</h2>
      {erreur && <p className="erreur">{erreur}</p>}
      <div className="champ">
        <label htmlFor="nom">Nom</label>
        <input id="nom" value={nom} onChange={(e) => setNom(e.target.value)} required />
      </div>
      <div className="champ">
        <label htmlFor="slug">Adresse du portail</label>
        <input id="slug" value={slug} placeholder={auto(nom)} onChange={(e) => setSlug(e.target.value)} />
        <p className="aide">{(slug || auto(nom))}.{domaine}</p>
      </div>
      <div className="champ">
        <label htmlFor="pop">Population</label>
        <input id="pop" type="number" value={pop} onChange={(e) => setPop(e.target.value)} />
      </div>
      <p className="aide">Huit démarches courantes seront installées d'emblée, en brouillon.</p>
      <button className="btn pri">Créer le portail</button>
    </form>
  )
}

const auto = (nom) => nom.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/^(mairie|commune|ville) (de |d')?/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
